module.exports = __webpack_public_path__ + "static/media/icon-equipe-grey.58206b39.svg";